import { useState } from 'react';

import type { SimulatorChannel } from '@/backendApis';
import { XStack, YStack } from '@/components/ui/layout/layout';

import { SimulatorComposer } from './channel-simulator-composer';
import { SimulatorControls } from './channel-simulator-controls';
import { SimulatorEvents } from './channel-simulator-events';
import {
  useSimulatorComposer,
  useSimulatorSessionId,
} from './channel-simulator.hooks';
import { useSimulatorEventsQuery } from './channel-simulator.query';
import { SIMULATOR_CHANNEL_LABELS } from './channel-simulator.types';

export const ChannelSimulator = () => {
  const [sessionId, setSessionId] = useSimulatorSessionId();
  const [channel, setChannel] = useState<SimulatorChannel>('imessage');
  const composer = useSimulatorComposer(sessionId, channel);
  const events = useSimulatorEventsQuery(sessionId);

  return (
    <XStack className="h-full w-full gap-6 overflow-hidden p-6">
      <SimulatorControls
        sessionId={sessionId}
        onSessionIdChange={setSessionId}
        channel={channel}
        onChannelChange={setChannel}
        onPrefill={composer.setText}
      />
      <YStack className="min-h-0 min-w-0 flex-1 gap-3">
        <SimulatorEvents
          key={sessionId}
          events={events.data?.events ?? []}
          channel={channel}
        />
        {events.error && (
          <span className="text-xs text-danger-11">
            Event log unavailable: {events.error.message}
          </span>
        )}
        <SimulatorComposer
          composer={composer}
          placeholder={`Message as the ${SIMULATOR_CHANNEL_LABELS[channel]} device`}
        />
      </YStack>
    </XStack>
  );
};
